export const prices = [
    {
        _id : 0,
        name : "₹200-₹499",
        array:[200,499]
    },
    {
        _id : 1,
        name : "₹500-₹999",
        array:[500,999]
    },
    {
        _id : 2,
        name : "₹1000-₹1999",
        array:[1000,1999]
    },
    {
        _id : 3,
        name : "₹2000-₹4999",
        array:[2000,4999]
    },
    {
        _id : 4,
        name : "₹5000-₹9999",
        array:[5000,9999]
    },
    {
        _id : 5,
        name : "₹10000+",
        array:[10000,9999999]
    }
]